/**
 * CR-9072: the truck the haulier sends — the codes the server stores and how
 * each reads on screen.
 */
import type { TruckType } from '../../../lib/api';

export const TRUCK_TYPE_OPTIONS: ReadonlyArray<{ value: TruckType; label: string }> = [
  { value: 'standard', label: 'Standard Truck' },
  { value: 'mega', label: 'Mega Truck' },
];

/**
 * A stored truck type as it reads on screen.
 *
 * @param value - the stored code, or blank
 * @returns its label, or '' when none is set
 */
export function truckTypeLabel(value: string | null | undefined): string {
  return TRUCK_TYPE_OPTIONS.find(option => option.value === value)?.label ?? (value || '');
}
